import { useAuth } from '@wui/common-library'
import jwtDecode from 'jwt-decode'
import { computed, Plugin, watchEffect } from 'vue'

import { useStoreSettingsServicesAndPackages } from '@/entities/settings-permission-and-services'
import { useStoreProfile } from '@/entities/user-profile'

import { appBaseUrl, isElectron, tauriMode } from '@/shared/utils/import-meta'

export const onAuthReadyPlugin: Plugin  = {
  install: () => {
    const { token } = useAuth()
    const isTokenValid = computed(() => {
      if (!token.value) {
        return false
      }
      const decoded = jwtDecode<{ exp: number }>(token.value)
      const now = Date.now() / 1000
      return decoded.exp && decoded.exp > now
    })

    let pingRequestsInterval: NodeJS.Timeout | null = null

    const enablePingRequests = () => {
      pingRequestsInterval = setInterval(() => {
        fetchUserData()
      }, 1000 * 60 * 5) // WUI-924: Уменьшили с 3 до 1 минуты для быстрого обновления webSoftphoneEnabled
    }

    const disablePingRequests = () => {
      if(pingRequestsInterval) {
        clearInterval(pingRequestsInterval)
      }
    }

    const fetchUserData = async () => {
      try {
        const { loadPermissionGroup, loadServicesList } = useStoreSettingsServicesAndPackages()
        const { fetchProfile } = useStoreProfile()
        const { useStorePickupCall } = await import('@/entities/pickup-call')
        const { fetchAndSubscribePickupCalls } = useStorePickupCall()

        await loadPermissionGroup()
        await loadServicesList()
        await fetchProfile()
        await fetchAndSubscribePickupCalls()
      } catch (e) {
        console.error(e)
      }
    }

    watchEffect(() => {
      disablePingRequests()
      if (isTokenValid.value) {
        fetchUserData()
        enablePingRequests()
      }
      if (tauriMode()) {
        import('@tauri-apps/api/core').then(({ invoke }) => {
          invoke('set_auth_token', { token: token.value })
        })
      } else if (isElectron()) {
        window.electronAPI?.setAuthToken?.(token.value || '', appBaseUrl())
      }
    })
  },
}
